import { DateTime, DateTimeFormatOptions } from 'luxon'

const TRANSFER_CUT_OFF_TIME = DateTime.fromObject({
  hour: 15,
  second: 59,
  zone: 'America/New_York'
})

const TIME_FORMAT = Object.assign(DateTime.TIME_WITH_SHORT_OFFSET, {
  second: undefined
} as DateTimeFormatOptions)

export const formatCutOffTime = TRANSFER_CUT_OFF_TIME.toLocaleString(TIME_FORMAT)

export const localCutOffTime = TRANSFER_CUT_OFF_TIME.setZone('local')
export const formatLocalCutOffTime = localCutOffTime.toLocaleString(TIME_FORMAT)

export const inDiffTimezone = () => {
  return localCutOffTime.zoneName !== TRANSFER_CUT_OFF_TIME.zoneName
}

export const isAfterHours = (localTime?: DateTime) => {
  const currentLocalTime = localTime ? localTime : DateTime.local()
  return currentLocalTime > localCutOffTime
}
